import React from 'react';
import { Card, CardContent } from '../../components/ui/card';

const VolunteerTerms = () => {
  return (
    <div className="min-h-screen bg-cream" data-testid="volunteer-terms-page">
      <section className="bg-terracotta py-16">
        <div className="max-w-4xl mx-auto px-4">
          <h1 className="font-heading text-4xl text-white">Volunteer Terms</h1>
          <p className="font-body text-white/80 mt-2">Last updated: January 2026</p>
        </div>
      </section>
      
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Card className="bg-white rounded-2xl border-none shadow-sm">
            <CardContent className="p-8 md:p-12 space-y-8 font-body text-gray-700 leading-relaxed">
              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Welcome Volunteers</h2>
                <p>Thank you for your interest in volunteering with Dharma Astra Association. Your service (seva) is invaluable to our mission of preserving Dharma and serving humanity. Please review these terms before registering as a volunteer.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Eligibility</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Volunteers must be at least 18 years of age (or have parental consent for ages 14-17).</li>
                  <li>Volunteers must provide accurate personal information during registration.</li>
                  <li>Certain activities may require background verification.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Volunteer Responsibilities</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Perform assigned duties with dedication and integrity.</li>
                  <li>Follow instructions provided by coordinators and supervisors.</li>
                  <li>Maintain respectful behavior towards other volunteers, staff, and beneficiaries.</li>
                  <li>Protect the confidentiality of sensitive organizational information.</li>
                  <li>Report any concerns, incidents, or safety issues to coordinators.</li>
                  <li>Adhere to the organization's code of conduct and policies.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Code of Conduct</h2>
                <p className="mb-4">All volunteers are expected to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Treat everyone with respect, dignity, and compassion.</li>
                  <li>Maintain appropriate dress code during temple services and events.</li>
                  <li>Refrain from using the organization's name for personal benefit.</li>
                  <li>Not engage in any form of discrimination or harassment.</li>
                  <li>Avoid consuming alcohol or tobacco during volunteer activities.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Time Commitment</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Volunteers should honor their committed time and availability.</li>
                  <li>If unable to attend a scheduled activity, please inform coordinators at least 24 hours in advance.</li>
                  <li>Regular non-participation without notice may result in removal from the volunteer program.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Liability & Insurance</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Volunteers participate at their own risk.</li>
                  <li>The organization is not liable for any injuries sustained during volunteer activities, except where caused by organizational negligence.</li>
                  <li>Volunteers are responsible for their own health and medical insurance.</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Photography & Media</h2>
                <p>By volunteering, you grant Dharma Astra Association permission to use photographs and videos featuring you for promotional and documentary purposes. If you wish to opt out, please inform us in writing.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Termination</h2>
                <p>Either party may terminate the volunteer relationship at any time. The organization reserves the right to end a volunteer's participation if they violate these terms or engage in conduct detrimental to the organization's mission.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl text-gray-900 mb-4">Recognition</h2>
                <p>Active volunteers may receive certificates of appreciation and recognition at our annual events. Outstanding volunteers may be featured in our newsletters and social media.</p>
              </div>

              <div>
                <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Contact Us</h2>
                <p>For volunteer-related queries:</p>
                <p className="mt-2">Email: support@dharma-astra.org<br />Phone: +91 8977116677</p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default VolunteerTerms;
